// Colors for showing different data sets
const QUALITATIVE_COLORS: Array<string> = [
  '--ids-chart-color-accent-01',
  '--ids-chart-color-accent-02',
  '--ids-chart-color-accent-03',
  '--ids-chart-color-accent-04',
  '--ids-chart-color-accent-05',
  '--ids-chart-color-accent-06',
  '--ids-chart-color-accent-07',
  '--ids-chart-color-accent-08',
  '--ids-chart-color-accent-09',
  '--ids-chart-color-accent-10',
  '--ids-chart-color-accent-11',
  '--ids-chart-color-accent-12',
  '--ids-chart-color-accent-13',
  '--ids-chart-color-accent-14',
  '--ids-chart-color-accent-15',
  '--ids-chart-color-accent-16',
  '--ids-chart-color-accent-17',
  '--ids-chart-color-accent-18',
  '--ids-chart-color-accent-19',
  '--ids-chart-color-accent-20'
];

export {
  QUALITATIVE_COLORS
};
